import { fade, makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ custom, palette }: Theme) => ({
  button: {
    lineHeight: 1.25,
    letterSpacing: 'normal',
    padding: '15px 42px',
    fontFamily: 'Lato',
  },
  disabled: {},
  contained: {
    '&$disabled': {
      backgroundColor: fade(palette.primary.main, 0.5),
      color: palette.common.white,
      boxShadow: custom.shadow[1],
    },
  },
}));
